import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Link } from 'react-router-dom';
import numeral from 'numeral';

import {
	setPlanOrder,
	getOrderValue,
	updateAddressOrder
} from '../../_redux/actions/order';
import { FiAlertCircle } from 'react-icons/fi';
import LoadingB from '../../Components/LoadingBeneficiario';

import {
	FaThumbsUp,
	FaPlusCircle,
	FaCheckCircle,
	FaTimesCircle,
	FaRegEdit,
	FaTrashAlt,
	FaPercentage
} from 'react-icons/fa';

import { getPlanList } from '../../_redux/actions/plan';

import {
	applyCupom,
	removeCupom,
	clearCupomError
} from '../../_redux/actions/cupom';
import {
	removeSubscription,
	addEditSubscription
} from '../../_redux/actions/subscription';
import OrderResumePayment from '../../style/styledComponents/OrderResumePayment';
import TitlePayment from '../../style/styledComponents/TitlePayment';
import FormButton from '../../style/styledComponents/FormButton';
import { originUtils } from '../../utils';

class OrderResume extends Component {
	constructor(props) {
		super(props);

		this.state = {
			cupomId: '',
			editDeliveryAddress: false,
			confirmRemove: false,
			setCupom: true,
			isComplete: false,
			isLoading: false
		};

		this.openSubscriptionOptions = this.openSubscriptionOptions.bind(this);
		this.closeSubscriptionOptions = this.closeSubscriptionOptions.bind(this);
		this.removeSubscription = this.removeSubscription.bind(this);
		this.editSubscription = this.editSubscription.bind(this);
		this.changeCupom = this.changeCupom.bind(this);
		this.showAddCupom = this.showAddCupom.bind(this);
		this.applyCupom = this.applyCupom.bind(this);
		this.removeCupom = this.removeCupom.bind(this);
		this.changeDeliveryAddress = this.changeDeliveryAddress.bind(this);
		this.closeDeliveryAddress = this.closeDeliveryAddress.bind(this);
		this.removeConfirmation = this.removeConfirmation.bind(this);
	}

	componentDidMount() {
		let { Cupom } = this.props;
		if (Object.keys(Cupom.data).length > 0) {
			this.setState({
				setCupom: false
			});
		}
	}

	componentDidUpdate(prevProps) {
		let { Order, CmDrConsulta } = this.props;
		if (Order.data.planId !== prevProps.Order.data.planId || Order.value.total !== prevProps.Order.value.total) {
			if (!Order.value.total) {
				this.props.getOrderValue(Order.data.orderId, CmDrConsulta.paymentMethod.pix);
			}
		}
	}

	findPlanById(planId) {
		let dataReturn = null;
		let { Plan } = this.props;
		if (!Plan.list.error) {
			Plan.list.forEach(planItem => {
				if (planItem.planId === planId) {
					dataReturn = planItem;
				}
			});
		}

		return dataReturn;
	}
	async applyCupom() {
		let { Order } = this.props;
		let cupomId = this.state.cupomId;
		let orderId = Order.data.orderId;
		const origin = originUtils.getOrigin()
		let hasError = '';
		this.setState({
			isLoading: true
		});
		if (orderId && cupomId) {
			await this.props.applyCupom(orderId, cupomId, origin).then(valor => {
				if (valor === false) {
					this.showAddCupom();
				}
			});
		}
		this.setState({
			isLoading: false
		});
	}

	async removeCupom() {
		let { Order, Cupom } = this.props;
		let cupomId = Cupom.data.cupomId;
		let orderId = Order.data.orderId;
		let cuponsUsedId = Cupom.data.cuponsUsedId;
		this.setState({
			isLoading: true
		});
		if (orderId && cupomId) {
			await this.props.removeCupom(cuponsUsedId).then(error => {
				if (error === false) {
					this.showAddCupom();
				}
			});
		}
		this.setState({
			isLoading: false
		});
	}

	removeSubscription(valueId, valueAddressId, valueName) {
		let id = valueId;
		let name = valueName;
		let address = valueAddressId;
		let subscriptionOption = id + '|' + name + '|' + address;
		let subscriptionData = subscriptionOption.split('|');
		let subscriptionId = subscriptionData[0];
		let addressId = subscriptionData[2];

		this.props.removeSubscription(subscriptionId, addressId);
		this.setState({ confirmRemove: false });
	}

	removeConfirmation(valueId, valueAddressId, valueName) {
		this.setState({
			confirmRemove: true,
			valueId: valueId,
			valueAddressId: valueAddressId,
			valueName: valueName
		});
	}

	editSubscription() {
		let { loja } = this.props.match.params;
		let { Order } = this.props;
		let addressId = Order.data.addressId;
		let planId = Order.data.planId;

		let planType = sessionStorage.getItem('planType');

		if (this.state.subscriptionOption) {
			let subscriptionData = this.state.subscriptionOption.split('|');
			let subscriptionId = subscriptionData[0];
			let { Subscription } = this.props;

			const userToBeEditted = Subscription.data.itens.find(
				assinante => assinante.subscriptionId === subscriptionId
			);

			let position;
			for (var i = 0; i < Subscription.data.itens.length; i++) {
				if (Subscription.data.itens[i].subscriptionId === subscriptionId) {
					position = i;
					break;
				}
			}
			userToBeEditted.position = position;
			this.props.history.push({
				pathname: process.env.PUBLIC_URL + `/${loja}/beneficiario`,
				search: `?assinatura=${planType}&isediting=${addressId}&planId=${planId}`,
				isEditting: { userToBeEditted }
			});
		}
	}

	subscriptionOptions() {
		let { Subscription } = this.props;
		let optionElm = '';
		if (this.state.subscriptionOption) {
			let subscriptionData = this.state.subscriptionOption.split('|');
			let name = subscriptionData[1];
			let optionItens = [];

			optionItens.push(
				<FormButton>
					<span
						className='overlay-box--close f-bold btn-border-color-yes'
						key='1'
						onClick={this.editSubscription}>
						<FaCheckCircle size={20} /> Sim
					</span>
				</FormButton>
			);

			optionItens.push(
				<FormButton>
					<span
						key='3'
						onClick={this.closeSubscriptionOptions}
						className='overlay-box--close f-bold btn-border-color-not'>
						<FaTimesCircle size={20} /> Não
					</span>
				</FormButton>
			);

			optionElm = (
				<div className='overlay' style={{ display: 'block' }}>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							<h3>Deseja alterar os dados de {name}?</h3>
						</div>
						<div className='overlay-button'>{optionItens}</div>
					</div>
				</div>
			);
		}

		return optionElm;
	}

	openSubscriptionOptions(valueId, valueAddressId, valueName) {
		let id = valueId;
		let name = valueName;
		let address = valueAddressId;
		this.setState({
			subscriptionOption: id + '|' + name + '|' + address
		});
	}
	closeSubscriptionOptions() {
		this.setState({
			subscriptionOption: null
		});
	}
	showAddCupom() {
		this.setState(state => {
			return {
				setCupom: !state.setCupom
			};
		});
	}
	getPlanData(planId) {
		let { Plan } = this.props;

		let planData = {};

		Plan.list.forEach(planItem => {
			if (planItem.planId === planId) {
				planData = planItem;
			}
		});

		return planData;
	}
	changeCupom(e) {
		let value = e.target.value;

		value = value.toUpperCase();
		if (value.length > 0) {
			this.setState({
				isComplete: true
			});
		} else {
			this.setState({
				isComplete: false
			});
		}
		this.setState({
			cupomId: value
		});
	}
	getDeliveryAddress() {
		let { Order, Address } = this.props;

		let addressId = Order.data.addressId;
		let addressData = {};

		Address.data.itens.forEach((addressItem, index) => {
			if (addressId === addressItem.addressId) {
				addressData = addressItem;
				addressData.indexPos = index;
			}
		});

		//if (!addressData.addressId && addressId === Address.delivery.addressId) {
		addressData = Address.delivery;
		//}

		return addressData;
	}
	changeDeliveryAddress() {
		this.setState({
			editDeliveryAddress: true
		});
	}
	closeDeliveryAddress() {
		this.setState({
			editDeliveryAddress: false
		});
	}
	applyDeliveryAddress(addressId) {
		let planType = sessionStorage.getItem('planType');
		let { Order } = this.props;
		let { loja } = this.props.match.params;
		if (addressId) {
			this.props.updateAddressOrder(Order.data.orderId, addressId);
			this.closeDeliveryAddress();
		} else {
			this.props.history.push(
				process.env.PUBLIC_URL +
					`/${loja}/enderecoEntrega?assinatura=${planType}`
			);
		}
	}
	loading() {
		let { Order } = this.props;
		
		if (Order.loading) {
			return (
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-end',
						marginLeft: 'auto',
						marginRight: '0'
					}}>
					<LoadingB type='spin' color='blue' size={13} />
				</div>
			);
		}

		const locale = 'pt-BR';
		const currency = 'BRL';
		const fullCurrencyFormat = new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currency
		});
		return fullCurrencyFormat.format(this.props.totalValue);
	}
	render() {
		let {
			Subscription,
			Order,
			Cupom,
			Address,
			GiftCode,
			VivoUser,
			CmDrConsulta,
			SignatureChosen,
			Plan,
			Auth,
			Levelled
		} = this.props;

		const { loja } = this.props.match.params;
		let orderValue = Order.value;
		const isEpay = GiftCode.data.status === 'success' ? true : false; //mock
		const isVivo = Object.keys(VivoUser.data).length > 0 ? true : false; // mock
		const isCmDrConsulta =
			Object.keys(CmDrConsulta.data).length > 0 ? true : false; // mock
		const isSignatureChosen =
			Object.keys(SignatureChosen.data).length > 0 ? true : false;
		const isLevelled = Levelled.data.status === 'success' ? true : false; //mock

		/*const mockDataEpay = {
			status: 'success',
			message: 'Code available to be redeemed',
			giftCode: {
				code: '9234567899900007853',
				status: 'ACTIVATED'
			},
			plan: {
				signatureType: 'saude',
				value: '179.70',
				name: 'YALO Saúde Trimestral'
			}
		};*/

		const signatureChosen = SignatureChosen.data;
		const cmDrConsulta = CmDrConsulta.data;
		const levelled = Levelled.data;

		const locale = 'pt-BR';
		const currency = 'BRL';
		const currencySimbol = 'R$ ';
		const numberFormat = '0,0.00';
		const fullCurrencyFormat = new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currency
		});
		const currencyFormat = new Intl.NumberFormat(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});

		let planData = this.getPlanData(Order.data.planId);

		let subscriptionCount = Subscription.data.itens.length;
		let orderTotalPlanValue = '';
		if (orderValue.total) {
			orderTotalPlanValue = fullCurrencyFormat.format(orderValue.planRealValue);
		}

		let orderGracePeriodValue = '';
		if (orderValue.total) {
			if (
				numeral(orderValue.gracePeriodValue).format(numberFormat) === '0.00'
			) {
				orderGracePeriodValue = '';
			} else {
				orderGracePeriodValue = fullCurrencyFormat.format(
					orderValue.gracePeriodValue
				);
			}
		}

		const planType = sessionStorage.getItem('planType');
		const dependentIsActive = planData.active_dependents;

		const novoBeneficiario = {
			pathname: `beneficiario`,
			search: 'assinatura=' + planType,
			skipFormAddress: true
		};

		let removeConfirmation = '';
		if (this.state.confirmRemove) {
			removeConfirmation = (
				<div className='overlay'>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							<p> Você gostaria de remover {this.state.valueName}? </p>
						</div>

						<FormButton className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-border-color-yes'
								onClick={() =>
									this.removeSubscription(
										this.state.valueId,
										this.state.valueAddressId,
										this.state.valueName
									)
								}>
								<FaCheckCircle size={20} /> Sim
							</button>
							<p> </p>
							<button
								className='overlay-box--close f-bold btn-border-color-not'
								onClick={() => this.setState({ confirmRemove: false })}>
								<FaTimesCircle size={20} /> Não
							</button>
						</FormButton>
					</div>
				</div>
			);
		}

		let planName = '';
		if (!Plan.list.length && Auth.login.logged) {
		} else if (Order.data.planId) {
			if (!orderValue.total) {
			//	this.props.getOrderValue(Order.data.orderId, CmDrConsulta.paymentMethod.pix);
			}

			let planData = this.findPlanById(Order.data.planId);

			planName =
				planData.signature_type === 'saude'
					? 'Saúde'
					: planData.signature_type === 'familia'
					? 'Família'
					: planData.signature_type.charAt(0).toUpperCase() +
					  planData.signature_type.slice(1);
			let planTime =
				planData.numberOfInstallment === '1'
					? 'Mensal'
					: planData.numberOfInstallment === '3'
					? 'Trimestral'
					: planData.numberOfInstallment === '6'
					? 'Semestral'
					: planData.numberOfInstallment === '12'
					? 'Anual'
					: '';

			if (planData) {
				planName = (
					<div className='order-item-aligment'>
						<div className='style-cards'>
							{dependentIsActive == true ? (
								<span>
									1x {'YALO ' + planName}
									<br />
								</span>
							) : (
								<span>
									{subscriptionCount}x {'YALO ' + planName + ' ' + planTime}
									<br />
								</span>
							)}
						</div>
					</div>
				);
			}
		}

		let deliveryAddressData = this.getDeliveryAddress();

		let deliveryAddress = '';
		if (this.state.editDeliveryAddress) {
			let addressButtons = [];

			Address.data.itens.forEach((addressItem, index) => {
				let disabled =
					deliveryAddressData.addressId === addressItem.addressId
						? { disabled: 'disabled' }
						: {};

				let SubscriptionDataItem = Subscription.data.itens[index];

				addressButtons.push(
					<button
						key={index}
						onClick={() => this.applyDeliveryAddress(addressItem.addressId)}
						{...disabled}>
						{SubscriptionDataItem.name}
						<br />
						<small>{addressItem.address}</small>
					</button>
				);
			});

			addressButtons.push(
				<FormButton>
					<button
						className='overlay-box--close f-bold btn-border-color-yes'
						key={addressButtons.length}
						onClick={() => this.applyDeliveryAddress()}>
						<FaCheckCircle size={20} /> Sim
					</button>
				</FormButton>
			);
			addressButtons.push(
				<FormButton>
					<button
						className='overlay-box--close f-bold btn-border-color-not'
						key={addressButtons.length}
						onClick={this.closeDeliveryAddress}>
						<FaTimesCircle size={20} /> Não
					</button>
				</FormButton>
			);

			deliveryAddress = (
				<div className='overlay'>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							<h3>Deseja editar o endereço?</h3>
						</div>
						<div className='overlay-button'>{addressButtons}</div>
					</div>
				</div>
			);
		}

		let deliveryInfo = '';

		let deliverySubscriptionData = {};

		if (deliveryAddressData.indexPos) {
			deliverySubscriptionData =
				Subscription.data.itens[deliveryAddressData.indexPos];
		}

		if (deliveryAddressData && deliverySubscriptionData) {
			let cep = deliveryAddressData.cep;
			var formatedCep = cep.substr(0, 5) + '-' + cep.substr(5);
			// o código abaixo é só para teste:
			deliveryInfo = (
				<div>
					<div className='boxAddress'>
						<h4>
							{this.state.hasUsedCard ? 'Endereço de entrega' : 'Endereço'}
						</h4>
						<div className='address-resume'>
							<div className='address-item-aligment'>
								<div className='address-style-cards'>
									<span>
										{formatedCep + ' - '}
										{deliverySubscriptionData.name ||
											deliveryAddressData.address +
												', ' +
												deliveryAddressData.number +
												', '}
										{deliveryAddressData.complement
											? deliveryAddressData.complement + ', '
											: ''}
										{deliveryAddressData.city +
											', ' +
											deliveryAddressData.state}
									</span>
								</div>
							</div>
							<button className='regedit' onClick={this.changeDeliveryAddress}>
								<div className='icon-container'>
									<FaRegEdit size={18} />
								</div>
							</button>
						</div>
					</div>
				</div>
			);
		}

		if (dependentIsActive == true) {
			var assinantes = <></>;
		} else if (isEpay || isVivo || isLevelled) {
			var assinantes = (
				<div className='assinantes'>
					<h4>Assinante</h4>
				</div>
			);
		} else {
			var assinantes = (
				<div className='assinantes'>
					{Subscription.data.itens.length > 1 && <h4>Assinantes</h4>}
					{Subscription.data.itens.length <= 1 && <h4>Assinante</h4>}
					<Link to={novoBeneficiario}>
						<FaPlusCircle size={16} />
					</Link>
				</div>
			);
		}

		if (loja === 'familia' || dependentIsActive == true) {
			//loja familia, quando a loja e assinatura for familia ele entra nessa condição
			//e renderiza os nomes do assinante junto com seus dependentes normalmemente
			//a unica diferençã é os icones que diferenciam assinantes e dependentes
			//Obs: da pra componentizar esse trecho do código.
			const subscriptionHolder = Subscription.data.itens[0];
			const subscriptionDependent = Subscription.data.itens.slice();
			subscriptionDependent.splice(0, 1);

			var subscriptions = (
				<>
					<div className='assinantes'>
						<h4>Titular</h4>
					</div>

					<li>
						<div className='cards-item'>
							<div className='cards-item-aligment'>
								<div className='style-cards'>
									<span>
										{subscriptionHolder.cpf} | {subscriptionHolder.name}
									</span>
								</div>
							</div>
							<div className='cards-align'>
								<button
									onClick={() =>
										this.openSubscriptionOptions(
											subscriptionHolder.subscriptionId,
											subscriptionHolder.addressId,
											subscriptionHolder.name
										)
									}>
									<div className='icon-container'>
										<FaRegEdit size={18} />
									</div>
								</button>
							</div>
						</div>
					</li>

					{signatureChosen.number_of_dependents > 0 ||
					cmDrConsulta.number_of_dependents > 0 ||
					levelled.number_of_dependents > 0 ? (
						<div className='assinantes'>
							<h4>
								Dependentes {subscriptionDependent.length}/
								{signatureChosen.number_of_dependents ||
									cmDrConsulta.number_of_dependents ||
									levelled.number_of_dependents}
							</h4>
							{subscriptionDependent.length <
								signatureChosen.number_of_dependents ||
							subscriptionDependent.length <
								cmDrConsulta.number_of_dependents ||
							subscriptionDependent.length < levelled.number_of_dependents ? (
								<Link to={novoBeneficiario}>
									<FaPlusCircle size={16} />
								</Link>
							) : (
								''
							)}
						</div>
					) : (
						''
					)}
					{subscriptionDependent.map((item, key) => (
						<li key={key}>
							<div className='cards-item'>
								<div className='cards-item-aligment'>
									<div className='style-cards'>
										<span>
											{item.cpf} | {item.name}
										</span>
									</div>
								</div>
								<div className='cards-align'>
									<div style={{ marginRight: '5px' }}>
										<button
											onClick={() =>
												this.removeConfirmation(
													item.subscriptionId,
													item.addressId,
													item.name
												)
											}>
											<div className='icon-container'>
												<FaTrashAlt size={16} color={'#797977'} />
											</div>
										</button>
									</div>
									<div>
										<button
											onClick={() =>
												this.openSubscriptionOptions(
													item.subscriptionId,
													item.addressId,
													item.name
												)
											}>
											<div className='icon-container'>
												<FaRegEdit size={20} />
											</div>
										</button>
									</div>
								</div>
							</div>
						</li>
					))}
				</>
			);
		} else if (Subscription.data.itens.length > 1) {
			var subscriptions = Subscription.data.itens.map((item, key) => {
				return (
					<li key={key}>
						<div className='cards-item'>
							<div className='cards-item-aligment'>
								<div className='style-cards'>
									<span>
										{item.cpf} | {item.name}
									</span>
								</div>
							</div>
							<div className='cards-align'>
								<div style={{ marginRight: '5px' }}>
									<button
										onClick={() =>
											this.removeConfirmation(
												item.subscriptionId,
												item.addressId,
												item.name
											)
										}>
										<div className='icon-container'>
											<FaTrashAlt size={16} color={'#797977'} />
										</div>
									</button>
								</div>
								<div>
									<button
										onClick={() =>
											this.openSubscriptionOptions(
												item.subscriptionId,
												item.addressId,
												item.name
											)
										}>
										<div className='icon-container'>
											<FaRegEdit size={20} />
										</div>
									</button>
								</div>
							</div>
						</div>
					</li>
				);
			});
		} else {
			var subscriptions = Subscription.data.itens.map((item, key) => {
				return (
					<li key={key}>
						<div className='cards-item'>
							<div className='cards-item-aligment'>
								<div className='style-cards'>
									<span>
										{item.cpf} | {item.name}
									</span>
								</div>
							</div>
							<div className='cards-align'>
								<button
									onClick={() =>
										this.openSubscriptionOptions(
											item.subscriptionId,
											item.addressId,
											item.name
										)
									}>
									<div className='icon-container'>
										<FaRegEdit size={18} />
									</div>
								</button>
							</div>
						</div>
					</li>
				);
			});
		}

		let errorElm = null;

		if (Cupom.data.error) {
			const errorMsg =
				Cupom.data.error === "This cupom can't used more - use exceded"
					? 'Este cupom está esgotado.'
					: 'Não foi possível aplicar ou remover o desconto.';
			errorElm = (
				<div className='overlay'>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							<p>{errorMsg}</p>
						</div>
						<FormButton className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-border-color-ok'
								onClick={() => this.props.clearCupomError(Cupom.data)}>
								<FaThumbsUp size={18} margin-right={'10px'} /> Ok
							</button>
						</FormButton>
					</div>
				</div>
			);
		}

		let addCupom = '';
		if (this.state.setCupom) {
			addCupom = (
				<tr>
					<td className='item-cupom'>
						<input
							type='text'
							className='form-control sizeFieldCupom '
							placeholder='Código do Cupom'
							onChange={this.changeCupom}
							value={this.state.cupomId}
						/>
					</td>
					{this.state.isLoading ? (
						<div className='apply-cupom'>
							<button className='waitingCupom'>
								<LoadingB type='spin' color='gray' size={20} />
							</button>
						</div>
					) : this.state.isComplete === true ? (
						<td className='apply-cupom'>
							<button className='apply-code' onClick={this.applyCupom}>
								<strong>APLICAR</strong>
							</button>
						</td>
					) : (
						<td className='apply-cupom '>
							<button className='isDisabledCart'>
								<strong>APLICAR</strong>
							</button>
						</td>
					)}
				</tr>
			);
		}

		let cupomValue = (
			<tr>
				<td></td>
			</tr>
		);

		if (Cupom.data.cupomId && !this.state.setCupom) {
			if (orderValue.formattedDiscountValue) {
				cupomValue = (
					<tr className='resume-cupom'>
						<td className='item'>
							<FaPercentage />{' '}
							<strong className='discount-name'>
								CUPOM: {Cupom.data.cupomId}
							</strong>
							<button
								className='remove-cupom'
								onClick={this.removeCupom}
								type='button'>
								<div className='icon-container'>
									<FaTrashAlt size={16} color={'#797977'} />
								</div>
							</button>
						</td>
						<td className='value'>{orderValue.formattedDiscountValue}</td>
					</tr>
				);
			}
		}
		let pixDiscount = (
			<tr>
				<td></td>
			</tr>
		);
		if( orderValue.pixDiscount != null){
			pixDiscount = (
				<tr className='resume-pix'>
					<td className='item'>
						<strong>
							Desconto: {orderValue.pixPercentage}% no Pix
						</strong>
					</td>
					<td className='value'>{orderValue.formattedPixDiscountValue}</td>
				</tr>
			);
		}
		let carenciaValue = (
			<tr>
				<td></td>
			</tr>
		);

		if (orderGracePeriodValue) {
			carenciaValue = (
				<tr>
					<td className='item'>{subscriptionCount}x Carência</td>
					<td className='value'>
						{fullCurrencyFormat.format(planData.gracePeriodTax)}
					</td>
				</tr>
			);
		}

		let deliveryValue = (
			<tr>
				<td></td>
			</tr>
		);
		let showDelivery = true;
		if (showDelivery) {
			deliveryValue =
				orderValue.deliveryPriceFormatted !== 'grátis' ? (
					''
				) : (
					<tr>
						<td className='item'>Taxa de Entrega</td>
						<td className='value'>{orderValue.deliveryPriceFormatted}</td>
					</tr>
				);
		}

		/*let cupomButton = null;

		if (!Cupom.data.cupomId && !this.state.setCupom) {
			cupomButton = (
				<button className='coupon-add' onClick={this.showAddCupom}>
					<small>Adicionar cupom</small>
				</button>
			);
		}
		*/
		let priceTable = null;
		if (isLevelled) {
			priceTable = (
				<div className='boxPrice'>
					<h4>Itens do pedido</h4>

					<div className='cards-item'>
						<div className='order-item-aligment'>
							<span>{this.props.Levelled.data.plan.name}</span>
						</div>
						<div className='cards-align'>
							<div
								className='icon-container'
								style={{ color: '#2b2b2b', fontWeight: 'bold' }}>
								{fullCurrencyFormat.format(this.props.Levelled.data.plan.value)}
							</div>
						</div>
					</div>

					<div className='cards-item'>
						<div className='order-item-aligment'>
							<span style={{ marginLeft: 0, color: '#008265' }}>
								<FaPercentage color={'#008265'} />
								CUPOMYALO
							</span>
						</div>
						<div className='cards-align'>
							<div
								className='value'
								style={{
									color: '#008265',
									fontWeight: 'bold',
									whiteSpace: 'nowrap'
								}}>
								-{' '}
								{fullCurrencyFormat.format(this.props.Levelled.data.plan.value)}
							</div>
						</div>
					</div>

					<table className='checkout-box' cellPadding={0} cellSpacing={0}>
						<tbody>
							<tr style={{ lineHeight: '25px' }}>
								<td
									style={{
										color: '#1a62f4',
										display: 'flex',
										alignItems: 'center'
									}}>
									TOTAL
								</td>
								<td style={{ color: '#1a62f4' }}>
									{fullCurrencyFormat.format(0)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			);
		} else if (isEpay) {
			priceTable = (
				<div className='boxPrice'>
					<h4>Itens do pedido</h4>

					<div className='cards-item'>
						<div className='order-item-aligment'>
							<span>{this.props.GiftCode.data.plan.name}</span>
						</div>
						<div className='cards-align'>
							<div
								className='icon-container'
								style={{ color: '#2b2b2b', fontWeight: 'bold' }}>
								{fullCurrencyFormat.format(this.props.GiftCode.data.plan.value)}
							</div>
						</div>
					</div>

					<div className='cards-item'>
						<div className='order-item-aligment'>
							<span style={{ marginLeft: 0, color: '#008265' }}>
								<FaPercentage color={'#008265'} />
								CUPOMYALO
							</span>
						</div>
						<div className='cards-align'>
							<div
								className='value'
								style={{
									color: '#008265',
									fontWeight: 'bold',
									whiteSpace: 'nowrap'
								}}>
								-{' '}
								{fullCurrencyFormat.format(this.props.GiftCode.data.plan.value)}
							</div>
						</div>
					</div>

					<table className='checkout-box' cellPadding={0} cellSpacing={0}>
						<tbody>
							<tr style={{ lineHeight: '25px' }}>
								<td
									style={{
										color: '#1a62f4',
										display: 'flex',
										alignItems: 'center'
									}}>
									TOTAL
								</td>
								<td style={{ color: '#1a62f4' }}>
									{fullCurrencyFormat.format(0)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			);
		} else if (isVivo) {
			priceTable = (
				<div className='boxPrice'>
					<h4>Itens do pedido</h4>

					<div className='cards-item'>
						<div className='order-item-aligment'>
							<span>{this.props.VivoUser.data.name}</span>
						</div>
						<div className='cards-align'>
							<div
								className='icon-container'
								style={{ color: '#2b2b2b', fontWeight: 'bold' }}>
								{fullCurrencyFormat.format(
									this.props.VivoUser.data.standard_value
								)}
							</div>
						</div>
					</div>

					<table className='checkout-box' cellPadding={0} cellSpacing={0}>
						<tbody>
							<tr style={{ lineHeight: '25px' }}>
								<td
									style={{
										color: '#609',
										display: 'flex',
										alignItems: 'center'
									}}>
									TOTAL
								</td>
								<td style={{ color: '#609' }}>
									{fullCurrencyFormat.format(0)}
								</td>
							</tr>
						</tbody>
					</table>
					<p>
						O pagamento da assinatura YALO é mensal e inclusa dentro da sua
						fatura VIVO.
					</p>
				</div>
			);
		} else if (isCmDrConsulta) {
			let price =
				dependentIsActive == true
					? Number(this.props.CmDrConsulta.data.price)
					: Number(this.props.CmDrConsulta.data.price) *
					  Number(this.props.Subscription.data.itens.length);
			priceTable = (
				<div className='boxPrice'>
					<h4>Itens do pedido</h4>

					<div className='cards-item'>
						<div className='order-item-aligment'>
							<span>
								1x {planData.name_description}
								<br />
							</span>
						</div>
						<div className='cards-align'>
							<div
								className='icon-container'
								style={{ color: '#2b2b2b', fontWeight: 'bold' }}>
								{fullCurrencyFormat.format(price)}
							</div>
						</div>
					</div>

					<table className='checkout-box' cellPadding={0} cellSpacing={0}>
						<tbody>
							{pixDiscount}
							{addCupom}
							{carenciaValue}
							{deliveryValue}
							{cupomValue}
							<tr style={{ lineHeight: '5px' }}>
								<td
									style={{
										color: '#0446C9',
										display: 'flex',
										alignItems: 'center'
									}}>
									TOTAL
								</td>
								<td>{this.loading()}</td>
							</tr>
						</tbody>
					</table>
				</div>
			);
		} else if (isSignatureChosen) {
			let price =
				dependentIsActive == true
					? Number(this.props.SignatureChosen.data.price)
					: Number(this.props.SignatureChosen.data.price) *
					  Number(this.props.Subscription.data.itens.length);

			priceTable = (
				<div className='boxPrice'>
					<h4>Itens do pedido</h4>

					<div className='cards-item'>
						<div className='order-item-aligment'>
							{loja === 'qualicorp' && dependentIsActive == true ? (
								<span>
									1x {planData.name_site}
									<br />
								</span>
							) : loja === 'yalo' ? (
								<span>
									{subscriptionCount}x {planData.name_description}
									<br />
								</span>
							) : dependentIsActive == true ? (
								<span>
									1x {planData.name_description}
									<br />
								</span>
							) : (
								<span>
									{subscriptionCount}x {planData.name_site}
									<br />
								</span>
							)}
						</div>
						<div className='cards-align'>
							<div
								className='icon-container'
								style={{ color: '#2b2b2b', fontWeight: 'bold' }}>
								{fullCurrencyFormat.format(price)}
							</div>
						</div>
					</div>

					<table className='checkout-box' cellPadding={0} cellSpacing={0}>
						<tbody>
							{addCupom}
							{carenciaValue}
							{deliveryValue}
							{cupomValue}
							<tr style={{ lineHeight: '5px' }}>
								<td
									style={{
										display: 'flex',
										alignItems: 'center'
									}}>
									TOTAL:
								</td>
								<td>{this.loading()}</td>
							</tr>
						</tbody>
					</table>
				</div>
			);
		} else if (orderTotalPlanValue) {
			let totalValue = fullCurrencyFormat.format(this.props.totalValue);

			priceTable = (
				<div className='boxPrice'>
					<h4>Itens do pedido</h4>

					<div className='cards-item'>
						{planName}
						<div className='cards-align'>
							<div
								className='value'
								style={{
									fontWeight: 'bold',
									whiteSpace: 'nowrap'
								}}>
								{orderTotalPlanValue}
							</div>
						</div>
					</div>

					<table className='checkout-box' cellPadding={0} cellSpacing={0}>
						<tbody>
							{addCupom}
							{carenciaValue}
							{deliveryValue}
							{cupomValue}
							<tr>
								<td className='item'> TOTAL:</td>
								<td className='value'> {totalValue}</td>
							</tr>
						</tbody>
					</table>
				</div>
			);
		}

		return (
			<>
				<div className='row'>
					{this.state.errorMsg && this.state.errorMsg.length && (
						<>
							<FiAlertCircle size={13} color={'red'} />
							<small className='credit-card-error'>{this.state.errorMsg}</small>
						</>
					)}
				</div>

				<div className='row'>
					<div className='form-step'>
						{deliveryAddress} {/*lixo*/}
						{errorElm}
					</div>
				</div>

				<TitlePayment>
					<div className='swiper-container'>
						<span>RESUMO DO PEDIDO</span>
					</div>
				</TitlePayment>
				<OrderResumePayment>
					{assinantes}
					<div className='assinantes-resume'>
						<ul className='cards'>
							{this.subscriptionOptions()}
							{subscriptions}
						</ul>
					</div>
					{deliveryInfo}

					{priceTable}
					{removeConfirmation}
				</OrderResumePayment>
			</>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setPlanOrder,
			getOrderValue,
			updateAddressOrder,
			applyCupom,
			removeCupom,
			clearCupomError,
			removeSubscription,
			addEditSubscription,
			getPlanList
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(OrderResume);
